import { toast } from 'react-toastify';
import { inactiveUser } from '../../services/apiVariable';
import { apiCall } from '../../services/api';
// import Snackbar from '@material-ui/core/Snackbar';

export const pauseSubscription = (id, subId, body) => new Promise((resolve, reject) => {
  inactiveUser.pauseSubscription.entityId = id;
  inactiveUser.pauseSubscription.subId = subId;
    
  apiCall({ ...inactiveUser.pauseSubscription, body })
    .then((res) => {
      //  dispatch({ type: homeStore.viewAllWallDetails, payload: res.data.data })
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      toast(err.data.message, { type: 'error' });
      console.log(err);
      reject(err);
    });
});

export const submitTeleCall = (body) => new Promise((resolve, reject) => {
  apiCall({ ...inactiveUser.submitTelecall, body })
    .then((res) => {
      //  dispatch({ type: homeStore.viewAllWallDetails, payload: res.data.data })
      if (res.status === 200) {
        resolve(res);
        toast(res.data.message, { type: 'success' });
      }
    })
    .catch((err) => {
      toast(err.data.message, { type: 'error' });
      // toast({ type: 'error', message: err.message });
      // console.log(err);
      reject(err);
    });
});
